export default Object.freeze({
    BACK_TEXT: 'Calculadoras',
    RESPONSE_PLACEHOLDER: 'Preencha os campos para visualizar o resultado',
    CONFIRM_DRUG_EXCLUSION: 'Excluir medicamento',
    DRUG_EXCLUSION: 'Deseja excluir o medicamento selecionado?',
    QUIT_CALCULATOR: 'Sair da calculadora',
    CONFIRMATION_QUIT_CALCULATOR: 'Deseja voltar e sair da calculadora? Os dados preenchidos serão perdidos.',

    ENTER_PATIENT_WEIGHT: 'Digite o peso do Paciente (kg)',
    ENTER_VOLUME: "Insira o volume",
    ENTER_PATIENT_WEIGHT_PLACEHOLDER: 'Insira o peso do paciente',
    ENTER_CURRENT_HEMATOCRIT: "Insira o hematócrito atual do paciente (%)",
    ENTER_INTENDED_HEMATOCRIT: "Insira o hematócrito pretendido do paciente (%)",
    ENTER_DONOR_HEMATOCRIT: "Insira o hematócrito do doador (%)",
    SELECT_OR_WRITE_TAX: "Selecione ou escreva a Taxa",
    ENTER_SPEED_AT_30_MINUTES: "Velocidade de Transfusão nos primeiros 30 minutos (mL/kg/hora)",
    ENTER_SPEED_AFTER_30_MINUTES: "Velocidade de Transfusão após os 30 primeiros minutos (mL/kg/hora)",
    ENTER_ANTICOAGULANT_VOLUME: "Volume de anticoagulante mantido na bolsa de transfusão (mL)",
    SOLUTION_COMPOSITION: "Volume de Sangue a ser Transfundido (mL)",
    LIQUIDS_VOLUME: "Volume dos líquidos",
    TIME_VOLUME: "Volume por tempo",
    SPEED: "Velocidade",
    MICRODROPS_SPEED: "Velocidade no equipo Microgotas",
    MACRODROPS_SPEED: "Velocidade no equipo Macrogotas",
    TRANSFUSION_DURATION: "Duração da Transfusão",
    TRANSFUSION_DURATION_SPEED_OBSERVATION: "Caso a velocidade se mantenha a informada, o volume será transfundido em:",
    SELECT_EQUIPMENT_TYPE: 'Selecione o Tipo de Equipo',
    DROPS_TO_VOLUME_INSTRUCTIONS: 'Clique no botão abaixo (gota) na mesma frequência do gotejamento do seu equipo.',

    UNIT_ML_KG_H: "mL/kg/hora",
    UNIT_DROPS_SECONDS: "gotas/segundo",
    UNIT_SECONDS_DROPS: "segundos/gota",
    UNIT_DROPS_MINUTES: "gotas/minuto",
    UNIT_DROPS_TEN_SECONDS: "gotas/10 segundos",

    CONTINUOUS_INFUSION_ID: 'continuous-infusion',
    TRANSFUSION_BLOOD_AND_SPEED_ID: 'transfusion-volume-speed',
    DOSE_CALCULATOR_ID: 'dose',
    RULE_OF_THREE_ID: 'rule-of-three',
    DROPS_TO_VOLUME: 'drops-to-volume',
    CALCULATORS_HEADERS: [
        {
            name: 'Convencional'
        },
        {
            name: 'Doses'
        },
        {
            name: 'Regra de Três'
        }
    ]
});